import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios, { API, authHeaders } from '../api';
import Layout from './Layout';
import { ui } from '../ui';
import { colors } from '../theme';
import DataTable from '../components/DataTable';
import { SPARK_TYPE_LABEL } from '../sparkTypeLabels';

function fmt(str) {
  return new Date(str).toLocaleString('ru', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export default function SparkTransactions() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  const fetchItems = useCallback(() => {
    axios.get(`${API}/admin/spark-transactions`, { headers: authHeaders() }).then(r => setItems(r.data));
  }, []);
  useEffect(() => { fetchItems(); }, [fetchItems]);

  return (
    <Layout>
      <h1 style={ui.title}>История искр</h1>
      <p style={{ color: colors.textMuted, fontSize: 13, marginTop: -10, marginBottom: 20 }}>
        Все начисления и списания искр по всем пользователям. Клик по пользователю открывает его анкету.
      </p>
      <div style={ui.card}>
        <DataTable
          rows={items}
          rowKey={t => t.id}
          emptyText="Транзакций пока нет"
          columns={[
            {
              key: 'user', label: 'Пользователь', sortValue: t => t.user.first_name || '',
              render: t => (
                <span
                  onClick={(e) => { e.stopPropagation(); navigate(`/applications?open=${t.user.id}`); }}
                  style={{ cursor: 'pointer' }}
                >
                  {t.user.first_name || '—'} ({t.user.phone})
                </span>
              ),
            },
            {
              key: 'amount', label: 'Сумма',
              render: t => (
                <span style={{ fontWeight: 600, color: t.amount > 0 ? colors.good : colors.danger }}>
                  {t.amount > 0 ? `+${t.amount}` : t.amount}
                </span>
              ),
            },
            { key: 'type', label: 'Тип', sortValue: t => SPARK_TYPE_LABEL[t.type] || t.type, render: t => SPARK_TYPE_LABEL[t.type] || t.type },
            { key: 'reference', label: 'Ссылка', render: t => t.reference || '—' },
            { key: 'created_at', label: 'Дата', render: t => fmt(t.created_at) },
          ]}
        />
      </div>
    </Layout>
  );
}
